import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-account-selector-page-ui',
    template: '',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AccountSelectorPageComponent {}
